import { useCallback, useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import "./PublicPuzzleApp.css";
import { useParams, useLocation } from "react-router";

import { makeGetPuzzleRequest } from "API/Puzzles";
import { setPublicPuzzleAndPuzzleType } from "Store/features/public/publicPuzzleSlice";
import { setPostcastAuthToken, setPublicUser } from "Store/features/public/publicUserSlice";
import { transpose, shuffleColumns } from "Util/validation";

import Modal from "Containers/Pages/Modal";
import PublicPuzzle from "Components/Games/PublicPuzzle";
import PublicPuzzleNotFound from "Components/Games/PublicPuzzle/PublicPuzzleNotFound";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function PublicPuzzleApp() {
  const [error, setError] = useState(null)
  const activeModal = useSelector(
    (state) => state.publicStateSlice.activeModal
  );

  const postcastUser = useSelector(
    (state) => state.publicUserSlice
  );
  const dispatch = useDispatch();
  const { puzzleId } = useParams();
  const query = useQuery();

  // Get the pcToken from the URL - make this an otp
  const authToken = query.get("pcToken");
    

  useEffect(() => {
    console.log("authToken", authToken);
    dispatch(setPostcastAuthToken(authToken));
  }, [authToken]);

  const getPuzzle = useCallback(async () => {
    const puzzleFromApi = await makeGetPuzzleRequest(dispatch, puzzleId, authToken);
    // Couldnt
    if (!puzzleFromApi) {
      setError(true)
      return;
    }
    // will include user if authenticated
    const { id, type, puzzle, user } = puzzleFromApi;
    // Initialize Newsie Redux
    if (type === "newsie") {
      dispatch(
        setPublicPuzzleAndPuzzleType({
          puzzleId: id,
          // Set Newsie Puzzle State
          puzzle: {
            ...puzzle,
            // Shuffle this will become gameboard
            newsieGrid: shuffleColumns(transpose(puzzle?.newsieInput)),
            selectedWords: new Array(puzzle?.newsieInput[0].length).fill(null),
            solvedStories: [],
            timer: {
              time: 0,
              timer_active: true,
            },
            incorrectGuesses: 0,
          },
          puzzleType: type,
        })
      );
    } else if (type === "crossword") {
      const { clues, grid, wordsAndClues } = puzzle;
      dispatch(
        setPublicPuzzleAndPuzzleType({
          puzzleId: id,
          // Set Newsie Puzzle State
          puzzle: {
            ...puzzle,
            selectedCell: [],
            timer: {
              time: 0,
              timer_active: true,
            },
            incorrectGuesses: 0,
          },
          puzzleType: type,
        })
      );
    } else if (type === "wordsearch") {
      const words = puzzle.words.map((w) => ({ word: w, found: false }));
      dispatch(
        setPublicPuzzleAndPuzzleType({
          puzzleId: id,
          // Set Newsie Puzzle State
          puzzle: {
            ...puzzle,
            // Shuffle this will become gameboard
            wordsearchGrid: puzzle.grid,
            words,
            solvedWords: [],
            timer: {
              time: 0,
              timer_active: true,
            },
            incorrectGuesses: 0,
          },
          puzzleType: type,
        })
      );
    } else if (type === "quiz") {
      dispatch(
        setPublicPuzzleAndPuzzleType({
          puzzleId: id,
          // Set Newsie Puzzle State
          puzzle: {
            ...puzzle,
            timer: {
              time: 0,
              timer_active: true,
            },
            incorrectAnswers: 0,
          },
          puzzleType: type,
        })
      );
    }

    if (user) {
      dispatch(setPublicUser(user));
    }
  }, [dispatch, puzzleId, authToken]);

  const {
    puzzleId: puzzleIdRedux,
    puzzleType,
    puzzle,
  } = useSelector((state) => state.publicPuzzleSlice);

  useEffect(() => {
    getPuzzle();
  }, [getPuzzle]);

  return (
    <div className="App">
      {error  ? (<PublicPuzzleNotFound />) : null}
      {puzzle && !error ? (
        <PublicPuzzle puzzle={puzzle} puzzleType={puzzleType} postcastUser={postcastUser}/>
      ) : null}
      {activeModal && (
        <Modal
          isPublic={true}
          shouldShowModal={Boolean(activeModal)}
          modal={activeModal}
        />
      )}
    </div>
  );
}

export default PublicPuzzleApp;
